module.exports = __webpack_public_path__ + "static/hiw-img2-cffbf532be6a6d9698178a11384ee48e.jpg";